import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const WidgetContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%; /* Adjusted to take full width */
  max-width: 550px; /* Added max-width for responsiveness */
  height: 100%;
  max-height: 550px; /* Added max-height for responsiveness */
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 8px; /* Added margin for spacing */
  margin-bottom: 8px; /* Added margin for spacing */
`;

const Dropdown = styled.select`
  margin: 15px;
  padding: 10px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #000;
  text-align: center;
  color: #2862ff;
  width: 60%; /* Adjusted width to be responsive */
`;

const TradingViewWidget = styled.div`
  width: 100%; /* Adjusted to take full width */
  max-width: 550px; /* Added max-width for responsiveness */
  height: 100%;
  max-height: 550px; /* Added max-height for responsiveness */
`;

const symbols = [
  { description: "Nifty", proName: "NSE:NIFTY" },
  { description: "Bank Nifty", proName: "NSE:BANKNIFTY" },
  { description: "Sensex", proName: "BSE:SENSEX" },
  { description: "HDFC Bank", proName: "NSE:HDFCBANK" },
  { description: "Reliance", proName: "NSE:RELIANCE" },
  { description: "ICICI Bank", proName: "NSE:ICICIBANK" },
  { description: "SBI", proName: "NSE:SBIN" },
  { description: "Infosys", proName: "NSE:INFY" },
  { description: "Axis Bank", proName: "NSE:AXISBANK" },
  { description: "Tata Motors", proName: "NSE:TATAMOTORS" },
  { description: "Kotak Bank", proName: "NSE:KOTAKBANK" },
  { description: "TCS", proName: "NSE:TCS" },
  { description: "Bajaj Finance", proName: "NSE:BAJFINANCE" },
  { description: "Tata Steel", proName: "NSE:TATASTEEL" },
  { description: "Wipro", proName: "NSE:WIPRO" },
  { description: "BPCL", proName: "NSE:BPCL" },
  { description: "ITC", proName: "NSE:ITC" },
  { description: "Adani Ports", proName: "NSE:ADANIPORTS" },
  { description: "Bandhan Bank", proName: "NSE:BANDHANBNK" },
  { description: "Bharti Airtel", proName: "NSE:BHARTIARTL" },
  { description: "HCL Tech", proName: "NSE:HCLTECH" },
  { description: "BEL", proName: "NSE:BEL" },
  { description: "IDFC First Bank", proName: "NSE:IDFCFIRSTB" },
  { description: "Asian Paints", proName: "NSE:ASIANPAINT" },
  { description: "Hindalco", proName: "NSE:HINDALCO" },
  { description: "L&T", proName: "NSE:LT" },
  { description: "HUL", proName: "NSE:HINDUNILVR" },
  { description: "Tech Mahindra", proName: "NSE:TECHM" },
  { description: "Maruti", proName: "NSE:MARUTI" },
  { description: "JSW Steel", proName: "NSE:JSWSTEEL" },
  { description: "UPL", proName: "NSE:UPL" },
  { description: "IRFC", proName: "NSE:IRFC" },
  { description: "NTPC", proName: "NSE:NTPC" }
];

const TradingViewComponent = () => {
  const [selectedSymbol, setSelectedSymbol] = useState(symbols[0].proName);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      interval: "15m",
      width: "100%", /* Adjusted width to be responsive */
      isTransparent: false,
      height: 400, /* Adjusted height for smaller size */
      symbol: selectedSymbol,
      showIntervalTabs: true,
      displayMode: "single",
      locale: "en",
      colorTheme: "light"
    });

    const widgetContainer = document.querySelector('.tradingview-widget-container__widget');
    widgetContainer.appendChild(script);

    return () => {
      widgetContainer.innerHTML = '';
    };
  }, [selectedSymbol]);

  return (
    <WidgetContainer>
      <TradingViewWidget className="tradingview-widget-container">
        <div className="tradingview-widget-container__widget"></div>
      </TradingViewWidget>
      <Dropdown onChange={(e) => setSelectedSymbol(e.target.value)} value={selectedSymbol}>
        {symbols.map((symbol, index) => (
          <option key={index} value={symbol.proName}>
            {symbol.description}
          </option>
        ))}
      </Dropdown>
    </WidgetContainer>
  );
};

export default TradingViewComponent;
